import { AlertTriangle } from "lucide-react";
import DataTable from "@/admin/DataTable";
import { useFetch, Panel, Empty, Loading, ErrorBox, fmtDate } from "@/admin/ui";

const FAILED = [
  { key: "email", label: "Email", render: (r) => <b>{r.email}</b> },
  { key: "ip", label: "IP", render: (r) => <span className="adm-sub">{r.ip}</span> },
  { key: "device", label: "Dispositivo", render: (r) => <span className="adm-sub">{r.device}</span> },
  { key: "created_at", label: "Fecha", render: (r) => fmtDate(r.created_at, true) },
];
const DEVICES = [
  { key: "device", label: "Dispositivo", render: (r) => <b>{r.device}</b> },
  { key: "logins", label: "Entradas", num: true },
  { key: "users", label: "Usuarios", num: true },
  { key: "last", label: "Último uso", render: (r) => <span className="adm-sub">{fmtDate(r.last, true)}</span> },
];

export default function AuditTab() {
  const { data, error } = useFetch("/admin/audit");
  if (error) return <ErrorBox />;
  if (!data) return <Loading />;
  return (
    <div className="adm-grid">
      <Panel title="Accesos sospechosos · últimas 24 h" testid="admin-audit-suspicious">
        {!data.suspicious.length ? <Empty text="No hay actividad sospechosa." testid="admin-audit-suspicious-empty" /> : data.suspicious.map((s, i) => (
          <div key={i} className="adm-list-item" data-testid={`admin-audit-suspicious-${i}`}>
            <span className="adm-row" style={{ flexWrap: "nowrap" }}><AlertTriangle size={16} color="#B45309" /><span><b>{s.target}</b><div className="adm-sub">{s.reason}</div></span></span>
            <span className="adm-sub">{s.count} · {fmtDate(s.last, true)}</span>
          </div>
        ))}
      </Panel>
      <Panel title="Intentos fallidos · últimos 7 días" testid="admin-audit-failed">
        <DataTable columns={FAILED} rows={data.failed.map((r, i) => ({ ...r, id: i }))} pageSize={10} testid="admin-audit-failed-table" emptyText="No hay intentos fallidos." />
      </Panel>
      <Panel title="Dispositivos · últimos 30 días" testid="admin-audit-devices">
        <DataTable columns={DEVICES} rows={data.devices.map((r) => ({ ...r, id: r.device }))} pageSize={10} testid="admin-audit-devices-table" emptyText="Sin dispositivos registrados." />
      </Panel>
    </div>
  );
}
